import Show from '../views/domains/show'

export default [
    {
        path: '/admin/domain/:id',
        name: 'domain-show',
        component: Show,
    }
]
